<template>
  <div class="container-fluid page">

    <div class="row">
      <div class="col">
        <h2 class="mt-4">Drop Analytics | Service Improvements</h2>
      </div>
    </div>

    <div class="row flex-grow-1">
      <div class="col">

        <!-- Panel START -->
        <div class="card mt-4 h-100">
          <iframe class="h-100" :src="baseUrl + '/stats/admin/kepler'"></iframe>
        </div>
        <!-- // Panel END -->

      </div>
    </div>

  </div>
</template>

<script>
  // Uses vue2-google-maps see documentation
  // https://github.com/xkjyeah/vue-google-maps/blob/HEAD/API.md#icon--object
  import GoogleMaps from 'vue2-google-maps';

  import RetailersService from '../../../services/RetailersService';
  import CharitiesService from '../../../services/CharitiesService';
  import DropsService from '../../../services/DropsService';

  import config from '../../../services/Config';

  export default {
    name: 'drop-analytics-operations',

    components: {
      
    },

    data() {
      return {
        baseUrl: config.apiBaseUrl,
        googleApiLoaded: false,
        // center: { lat: 51.5344, lng: -0.0694 }, // Shoreditch // TODO: Re-enable this
        center: { lat: 52.9246, lng: -1.4793 }, // Derby 
        enableRetailers: true,
        enableCharities: true,
        enableDropCounts: true,
        retailers: [],
        charities: [],
        drops: [],
        filter: null,
        iconRetailer: null,
        iconCharity: null,
        iconRetailerDropCount: null,
        iconCharityDropCount: null,
        styles: [
          {
              "featureType": "administrative",
              "elementType": "labels.text.fill",
              "stylers": [
                  {
                      "color": "#a09f9f"
                  }
              ]
          },
          {
              "featureType": "administrative.land_parcel",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#01ff00"
                  },
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "landscape",
              "elementType": "all",
              "stylers": [
                  {
                      "color": "#f2f2f2"
                  }
              ]
          },
          {
              "featureType": "poi",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "poi.park",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#d8f3e6"
                  },
                  {
                      "visibility": "on"
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "all",
              "stylers": [
                  {
                      "saturation": -100
                  },
                  {
                      "lightness": 45
                  }
              ]
          },
          {
              "featureType": "road.highway",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "simplified"
                  }
              ]
          },
          {
              "featureType": "road.highway",
              "elementType": "labels",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "road.arterial",
              "elementType": "labels.icon",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "transit",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "all",
              "stylers": [
                  {
                      "color": "#46bcec"
                  },
                  {
                      "visibility": "on"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#aee5f9"
                  }
              ]
          }      
        ]
      };
    },

    async created() {
      // Get all retailers
      try {
        const retailerRes = await RetailersService.getAll();
        this.retailers = retailerRes.data;
      }
      catch(err) {
        console.log('Fetching retailers error', {err});
        alert('Ooops, there was a problem fetching retailers... the page may have not loaded correctly.')
      }

      // Get all charities
      try {
        const charitiesRes = await CharitiesService.getAll();
        this.charities = charitiesRes.data;
      }
      catch(err) {
        console.log('Fetching Charities error', {err});
        alert('Ooops, there was a problem fetching charities... the page may have not loaded correctly.')
      }

      // Get all future booked drops
      try {
        const dropsRes = await DropsService.getAllFutureBookedDrops();
        this.drops = dropsRes.data;
      }
      catch(err) {
        console.log('Fetching Drops error', {err});
        alert('Ooops, there was a problem fetching drops... the page may have not loaded correctly.')
      }
    },
    
    mounted() {
      this.checkGoogleLoaded();
    },

    computed: {
      calcRetailers: function() {
        let retailers = this.retailers;

        if(this.filter) {
          if(this.filter === 'activated') {
            retailers = retailers.filter((item) => item.visible === true);
          }
          else if(this.filter === 'hidden') {
            retailers = retailers.filter((item) => item.visible === false);
          }
        }

        return this.enableRetailers ? retailers : []
      },

      calcCharities: function() {
        let charities = this.charities;

        if(this.filter) {
          if(this.filter === 'activated') {
            charities = charities.filter((item) => item.visible === true);
          }
          else if(this.filter === 'hidden') {
            charities = charities.filter((item) => item.visible === false);
          }
        }

        return this.enableCharities ? charities : []
      },

      calcRetailerDropCounts: function() {
        if(this.enableRetailers && this.enableDropCounts) {
          let retailers = this.calcRetailers.map((retailer) => {
            retailer.dropCount = this.drops.filter((drop) => drop.retailerId == retailer.id).length;
            return retailer;
          });

          return retailers;
        }

        return [];
      },

      calcCharitiesDropCounts: function() {
        if(this.enableCharities && this.enableDropCounts) {
          let charities = this.calcCharities.map((charity) => {
            charity.dropCount = this.drops.filter((drop) => drop.charityId == charity.id).length;
            return charity;
          });

          return charities;
        }

        return [];
      },
    },

    methods: {
      /**
       * Check if google maps api is loaded
       */
      checkGoogleLoaded:function(){
        if(!window.google || !window.google.maps) {
          // Handle google.maps not loaded
          setTimeout(this.checkGoogleLoaded,100);
          console.log('X window.google or window.google.maps not loaded');
          return;
        }
        console.log('√ window.google and window.google.maps now loaded');
        this.initMap();
      },

      /**
       * Initialise (After google maps api is loaded)
       */
      initMap:function(){
        this.googleApiLoaded = true;
        let mapElement = this.$refs.map;
        let bounds = new google.maps.LatLngBounds();

        this.iconRetailer = {
          url:'/img/icons/retailer-icon.png',
          scaledSize: new google.maps.Size(63, 63),   // Original 30x42
          size: new google.maps.Size(63, 63),   // Original 30x42
          origin: new google.maps.Point(0, 0),  // The origin for this image is (0, 0).
          anchor: new google.maps.Point(31.5, 31.5),  // The anchor for this image is the base of the flagpole at (0, 32).
          labelOrigin: new google.maps.Point(31.5, 63),
        };

        this.iconCharity = {
          url:'/img/icons/charity-icon.png',
          scaledSize: new google.maps.Size(63, 63),   // Original 30x42
          size: new google.maps.Size(63, 63),   // Original 30x42
          origin: new google.maps.Point(0, 0),  // The origin for this image is (0, 0).
          anchor: new google.maps.Point(31.5, 31.5),  // The anchor for this image is the base of the flagpole at (0, 32).
          labelOrigin: new google.maps.Point(31.5, 63),
        };

        this.iconRetailerDropCount = {
          url:'/img/icons/icon-circle-orange.png',
          scaledSize: new google.maps.Size(25, 25),   // Original 30x42
          origin: new google.maps.Point(0, 0),  // The origin for this image is (0, 0).
          anchor: new google.maps.Point(-5, 35),  // The anchor for this image is the base of the flagpole at (0, 32).
          labelOrigin: new google.maps.Point(12.5, 12),
        };

        this.iconCharityDropCount = {
          url:'/img/icons/icon-circle-cyan.png',
          scaledSize: new google.maps.Size(25, 25),   // Original 30x42
          origin: new google.maps.Point(0, 0),  // The origin for this image is (0, 0).
          anchor: new google.maps.Point(-5, 35),  // The anchor for this image is the base of the flagpole at (0, 32).
          labelOrigin: new google.maps.Point(12.5, 12),
        };
      },

      /**
       * Get the position of a place
       * @param {Object} place The data of the charity, bucket center or retailer
       */
      positionFromPlace: function(place) {
        return new google.maps.LatLng(place.lat, place.lng);
      },

      /**
       * 
       */
      onLeftClick:function(event)
      {
        
      },

      /**
       * 
       */
      onRightClick:function(event)
      {

      },

      /**
        * Get the position of a place
        * @param {Object} place The data of the charity or retailer that has been clicked
        */
      onMarkerClick: function(place) {
        // Emit markerClick event to parent element
        for(let i in this.places) {
          this.places[i].activeMarker = false;

          if(this.places[i].place_id == place.place_id) {
            this.places[i].activeMarker = true;
          }
        }

        // Animate map center to clicked marker
        this.$refs.map.panTo(this.positionFromPlace(place));
      },


      /**
       * The search location has been dragged
       * @param {Object} position 
       */
      onDragEnd:function(position)
      {
        // this.$emit('search-location-moved',{'lat':position.latLng.lat(),'lng':position.latLng.lng()});
      }
    }
  };
</script>

<style lang="scss" scoped>
    .page {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 200px);
  }

  .cols {
    > [class^="col-"] {
      height: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: center;
      justify-items: center;
      margin: 0;
      padding: 0;
      
      .col-header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 100px;
        padding: 1rem;
        border: 1px solid rgba(136, 152, 170, 0.15);
        border-left: none;
        // border-right: none;
        
        &.last {
          // border: 1px solid rgba(136, 152, 170, 0.15);
          border-right: none;
        }
      }
      
      .col-body {
        flex: 1;
        padding: 1rem;
        position: relative;
        overflow: hidden;
        border: 1px solid rgba(136, 152, 170, 0.15);
        border-top: none;
        border-left: none;
        // border-right: none;
        
        &.last {
          // border: 1px solid rgba(136, 152, 170, 0.15);
          border-right: none;
        }
      }
    }

    .google-map {
      height:100%;
      width:100%;
    }

    .toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 2.5rem;
      color: #aaa;

      > .custom-toggle {
        margin-left: 0.75rem;
      }
    }
  }
</style>
